// import React, { useState } from "react";

// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import { API_URL } from '../../Redux/apiSlice';
// /* endpoints */
// const FILE_UPLOAD_URL = `${API_URL}/file/ `;
// const BLOG_CREATE_URL = `${API_URL}/blog`;

// export default function BlogCreate() {
//     const [form, setForm] = useState({
//         title: "",
//         excerpt: "",
//         content: "",
//         metaTitle: "",
//         metaDescription: "",
//         metaTags: "",
//         image: null,
//         imagePreview: null,
//         isDraft: true, // DEFAULT YES
//     });

//     const [statusMsg, setStatusMsg] = useState(null);
//     const [submitting, setSubmitting] = useState(false);

//     const getAuthHeader = () => {
//         try {
//             const raw = localStorage.getItem("knighthuntToken") || "";
//             const token = raw.trim();
//             if (!token) return null;
//             return token.toLowerCase().startsWith("bearer ")
//                 ? token
//                 : `Bearer ${token}`;
//         } catch {
//             return null;
//         }
//     };

//     const onChangeText = (e) => {
//         const { name, value } = e.target;
//         setForm((s) => ({ ...s, [name]: value }));
//     };

//     const onPickImage = (e) => {
//         const file = e.target.files?.[0];
//         if (!file) return;

//         if (!file.type.startsWith("image/")) {
//             setStatusMsg({ type: "error", text: "Please select an image file." });
//             return;
//         }

//         if (form.imagePreview) URL.revokeObjectURL(form.imagePreview);
//         const preview = URL.createObjectURL(file);

//         setForm((s) => ({ ...s, image: file, imagePreview: preview }));
//         setStatusMsg(null);
//     };

//     const onDraftChange = (e) => {
//         setForm((s) => ({
//             ...s,
//             isDraft: e.target.value === "yes" ? true : false,
//         }));
//     };

//     const uploadWithFetch = async (file) => {
//         const fd = new FormData();
//         fd.append("image", file);

//         const auth = getAuthHeader();
//         const headers = auth ? { Authorization: auth } : {};

//         const resp = await fetch(FILE_UPLOAD_URL, {
//             method: "POST",
//             body: fd,
//             headers,
//             credentials: "include",
//         });

//         const body = await resp.json().catch(() => null);
//         const url = body?.response?.url || body?.data?.url || body?.url || "";

//         return { ok: resp.ok, url };
//     };

//     const createBlogRequest = async (payload) => {
//         const auth = getAuthHeader();

//         const resp = await fetch(BLOG_CREATE_URL, {
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json",
//                 ...(auth ? { Authorization: auth } : {}),
//             },
//             body: JSON.stringify(payload),
//             credentials: "include",
//         });

//         const body = await resp.json().catch(() => null);
//         return { ok: resp.ok, body };
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setSubmitting(true);
//         setStatusMsg(null);

//         try {
//             let uploadedUrl = "";

//             if (form.image) {
//                 const uploadResult = await uploadWithFetch(form.image);
//                 if (!uploadResult.ok || !uploadResult.url)
//                     throw new Error("Image upload failed.");
//                 uploadedUrl = uploadResult.url;
//             }

//             const payload = {
//                 title: form.title,
//                 excerpt: form.excerpt,
//                 content: form.content,
//                 metaTitle: form.metaTitle,
//                 metaDescription: form.metaDescription,
//                 metaTags: form.metaTags
//                     ? form.metaTags.split(",").map((t) => t.trim())
//                     : [],
//                 image: uploadedUrl,
//                 isDraft: form.isDraft, // ADD THIS
//             };

//             const createResult = await createBlogRequest(payload);
//             if (!createResult.ok)
//                 throw new Error(createResult.body?.message || "Create failed");

//             setStatusMsg({
//                 type: "success",
//                 text: "Blog created successfully!",
//             });

//             resetForm();
//         } catch (err) {
//             setStatusMsg({
//                 type: "error",
//                 text: err.message || "Something went wrong.",
//             });
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     const resetForm = () => {
//         if (form.imagePreview) URL.revokeObjectURL(form.imagePreview);

//         setForm({
//             title: "",
//             excerpt: "",
//             content: "",
//             metaTitle: "",
//             metaDescription: "",
//             metaTags: "",
//             image: null,
//             imagePreview: null,
//             isDraft: true,
//         });
//     };

//     return (
//         <div style={{ padding: 20, paddingTop: 100, maxWidth: 700, margin: "0 auto" }}>
//             {statusMsg && (
//                 <div
//                     style={{
//                         marginBottom: 12,
//                         padding: 12,
//                         borderRadius: 6,
//                         fontWeight: 500,
//                         background:
//                             statusMsg.type === "error" ? "#ffe5e5" : "#e6fff2",
//                         color:
//                             statusMsg.type === "error"
//                                 ? "#b30000"
//                                 : "#00663d",
//                     }}
//                 >
//                     {statusMsg.text}
//                 </div>
//             )}

//             <form
//                 onSubmit={handleSubmit}
//                 style={{
//                     padding: 20,
//                     borderRadius: 10,
//                     border: "1px solid #d7dde0",
//                     background: "#fafafa",
//                 }}
//             >
//                 {/* Title */}
//                 <div style={{ marginBottom: 16 }}>
//                     <label style={{ fontWeight: 600 }}>Title</label>
//                     <input
//                         name="title"
//                         value={form.title}
//                         onChange={onChangeText}
//                         required
//                         className="form-control"
//                         style={{ marginTop: 6 }}
//                     />
//                 </div>

//                 {/* Excerpt */}
//                 <div style={{ marginBottom: 16 }}>
//                     <label style={{ fontWeight: 600 }}>Excerpt</label>
//                     <textarea
//                         name="excerpt"
//                         value={form.excerpt}
//                         onChange={onChangeText}
//                         rows={2}
//                         className="form-control"
//                         style={{ marginTop: 6 }}
//                     />
//                 </div>

//                 {/* Content */}
//                 <div style={{ marginBottom: 16 }}>
//                     <label style={{ fontWeight: 600 }}>Content</label>
//                     {/* <textarea
//                         name="content"
//                         value={form.content}
//                         onChange={onChangeText}
//                         rows={6}
//                         className="form-control"
//                         style={{ marginTop: 6 }}
//                     /> */}
//                     <CKEditor
//                         name="content"
//                         value={form.content}
//                         editor={ClassicEditor}
//                         onChange={onChangeText}
//                         rows={6}
//                         className="form-control"
//                         style={{ marginTop: 6 }}
//                     />
//                 </div>

//                 {/* Draft (YES / NO) */}
//                 <div style={{ marginBottom: 16 }}>
//                     <label style={{ fontWeight: 600 }}>Draft</label>
//                     <select
//                         value={form.isDraft ? "yes" : "no"}
//                         onChange={onDraftChange}
//                         className="form-control"
//                         style={{ marginTop: 6 }}
//                     >
//                         <option value="yes">Yes (Draft)</option>
//                         <option value="no">No (Publish)</option>
//                     </select>
//                 </div>

//                 {/* Meta title */}
//                 <div style={{ marginBottom: 16 }}>
//                     <label style={{ fontWeight: 600 }}>Meta Title</label>
//                     <input
//                         name="metaTitle"
//                         value={form.metaTitle}
//                         onChange={onChangeText}
//                         className="form-control"
//                         style={{ marginTop: 6 }}
//                     />
//                 </div>

//                 {/* Meta description */}
//                 <div style={{ marginBottom: 16 }}>
//                     <label style={{ fontWeight: 600 }}>Meta Description</label>
//                     <textarea
//                         name="metaDescription"
//                         value={form.metaDescription}
//                         onChange={onChangeText}
//                         rows={3}
//                         className="form-control"
//                         style={{ marginTop: 6 }}
//                     />
//                 </div>

//                 {/* Meta tags (comma separated) */}
//                 <div style={{ marginBottom: 16 }}>
//                     <label style={{ fontWeight: 600 }}>
//                         Meta Tags (comma separated)
//                     </label>
//                     <input
//                         name="metaTags"
//                         value={form.metaTags}
//                         onChange={onChangeText}
//                         className="form-control"
//                         style={{ marginTop: 6 }}
//                     />
//                 </div>

//                 {/* Image Upload */}
//                 <div style={{ marginBottom: 16 }}>
//                     <label style={{ fontWeight: 600 }}>Image</label>
//                     <input
//                         type="file"
//                         accept="image/*"
//                         onChange={onPickImage}
//                         className="form-control"
//                         style={{ marginTop: 6 }}
//                     />

//                     {form.imagePreview && (
//                         <img
//                             src={form.imagePreview}
//                             alt="preview"
//                             style={{
//                                 marginTop: 10,
//                                 width: 100,
//                                 height: 100,
//                                 borderRadius: 8,
//                                 objectFit: "cover",
//                                 border: "1px solid #ccc",
//                             }}
//                         />
//                     )}
//                 </div>

//                 <button
//                     type="submit"
//                     disabled={submitting}
//                     className="btn btn-primary"
//                     style={{
//                         padding: "10px 14px",
//                         fontWeight: 600,
//                         width: "100%",
//                     }}
//                 >
//                     {submitting ? "Saving..." : "Save Blog"}
//                 </button>
//             </form>
//         </div>
//     );
// }



import React, { useState } from "react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { API_URL } from "../../Redux/apiSlice";

const FILE_UPLOAD_URL = `${API_URL}/file/`;
const BLOG_CREATE_URL = `${API_URL}/blog`;

export default function BlogCreate() {
    const [form, setForm] = useState({
        title: "",
        excerpt: "",
        content: "",
        metaTitle: "",
        metaDescription: "",
        metaTags: "",
        image: null,
        imagePreview: null,
        isDraft: true,
    });

    const [statusMsg, setStatusMsg] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const getAuthHeader = () => {
        try {
            const raw = localStorage.getItem("knighthuntToken") || "";
            const token = raw.trim();
            if (!token) return null;

            return token.startsWith("Bearer ") ? token : `Bearer ${token}`;
        } catch {
            return null;
        }
    };

    const onChangeText = (e) => {
        const { name, value } = e.target;
        setForm((s) => ({ ...s, [name]: value }));
    };

    const onPickImage = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        if (!file.type.startsWith("image/")) {
            setStatusMsg({ type: "error", text: "Please select an image file." });
            return;
        }

        if (form.imagePreview) URL.revokeObjectURL(form.imagePreview);
        const preview = URL.createObjectURL(file);

        setForm((s) => ({ ...s, image: file, imagePreview: preview }));
        setStatusMsg(null);
    };

    const onDraftChange = (e) => {
        setForm((s) => ({
            ...s,
            isDraft: e.target.value === "yes",
        }));
    };

    // Upload image
    const uploadWithFetch = async (file) => {
        const fd = new FormData();
        fd.append("image", file);

        const auth = getAuthHeader();
        const headers = auth ? { Authorization: auth } : {};

        const resp = await fetch(FILE_UPLOAD_URL, {
            method: "POST",
            body: fd,
            headers,
            credentials: "include",
        });

        const body = await resp.json().catch(() => null);
        const url = body?.response?.url || "";

        return { ok: resp.ok, url };
    };

    // Blog create API
    const createBlogRequest = async (payload) => {
        const auth = getAuthHeader();

        const resp = await fetch(BLOG_CREATE_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(auth ? { Authorization: auth } : {}),
            },
            body: JSON.stringify(payload),
            credentials: "include",
        });

        const body = await resp.json().catch(() => null);
        return { ok: resp.ok, body };
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setStatusMsg(null);

        try {
            let uploadedUrl = "";

            if (form.image) {
                const uploadResult = await uploadWithFetch(form.image);
                if (!uploadResult.ok)
                    throw new Error("Image upload failed.");
                uploadedUrl = uploadResult.url;
            }

            const payload = {
                title: form.title,
                excerpt: form.excerpt,
                content: form.content, // CKEditor CONTENT
                metaTitle: form.metaTitle,
                metaDescription: form.metaDescription,
                metaTags: form.metaTags
                    ? form.metaTags.split(",").map((t) => t.trim())
                    : [],
                image: uploadedUrl,
                isDraft: form.isDraft,
            };

            const createResult = await createBlogRequest(payload);

            if (!createResult.ok)
                throw new Error(createResult.body?.message || "Create failed");

            setStatusMsg({
                type: "success",
                text: "Blog created successfully!",
            });

            resetForm();
        } catch (err) {
            setStatusMsg({
                type: "error",
                text: err.message || "Something went wrong.",
            });
        } finally {
            setSubmitting(false);
        }
    };

    const resetForm = () => {
        if (form.imagePreview) URL.revokeObjectURL(form.imagePreview);

        setForm({
            title: "",
            excerpt: "",
            content: "",
            metaTitle: "",
            metaDescription: "",
            metaTags: "",
            image: null,
            imagePreview: null,
            isDraft: true,
        });
    };

    return (
        <div style={{ padding: 20, paddingTop: 100, maxWidth: 700, margin: "0 auto" }}>
            {statusMsg && (
                <div
                    style={{
                        marginBottom: 12,
                        padding: 12,
                        borderRadius: 6,
                        fontWeight: 500,
                        background: statusMsg.type === "error" ? "#ffe5e5" : "#e6fff2",
                        color: statusMsg.type === "error" ? "#b30000" : "#00663d",
                    }}
                >
                    {statusMsg.text}
                </div>
            )}

            <form
                onSubmit={handleSubmit}
                style={{
                    padding: 20,
                    borderRadius: 10,
                    border: "1px solid #d7dde0",
                    background: "#fafafa",
                }}
            >

                {/* Title */}
                <div style={{ marginBottom: 16 }}>
                    <label style={{ fontWeight: 600 }}>Title</label>
                    <input
                        name="title"
                        value={form.title}
                        onChange={onChangeText}
                        required
                        className="form-control"
                        style={{ marginTop: 6 }}
                    />
                </div>

                {/* Excerpt */}
                <div style={{ marginBottom: 16 }}>
                    <label style={{ fontWeight: 600 }}>Excerpt</label>
                    <textarea
                        name="excerpt"
                        value={form.excerpt}
                        onChange={onChangeText}
                        rows={2}
                        className="form-control"
                        style={{ marginTop: 6 }}
                    />
                </div>

                {/* Content (CKEditor FIXED) */}
                <div style={{ marginBottom: 16 }}>
                    <label style={{ fontWeight: 600 }}>Content</label>

                    <CKEditor
                        editor={ClassicEditor}
                        data={form.content}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            setForm((s) => ({ ...s, content: data }));
                        }}
                    />
                </div>

                {/* Draft */}
                <div style={{ marginBottom: 16 }}>
                    <label style={{ fontWeight: 600 }}>Draft</label>
                    <select
                        value={form.isDraft ? "yes" : "no"}
                        onChange={onDraftChange}
                        className="form-control"
                        style={{ marginTop: 6 }}
                    >
                        <option value="yes">Yes (Draft)</option>
                        <option value="no">No (Publish)</option>
                    </select>
                </div>

                {/* Meta Title */}
                <div style={{ marginBottom: 16 }}>
                    <label style={{ fontWeight: 600 }}>Meta Title</label>
                    <input
                        name="metaTitle"
                        value={form.metaTitle}
                        onChange={onChangeText}
                        className="form-control"
                        style={{ marginTop: 6 }}
                    />
                </div>

                {/* Meta Description */}
                <div style={{ marginBottom: 16 }}>
                    <label style={{ fontWeight: 600 }}>Meta Description</label>
                    <textarea
                        name="metaDescription"
                        value={form.metaDescription}
                        onChange={onChangeText}
                        rows={3}
                        className="form-control"
                        style={{ marginTop: 6 }}
                    />
                </div>

                {/* Meta Tags */}
                <div style={{ marginBottom: 16 }}>
                    <label style={{ fontWeight: 600 }}>Meta Tags (comma separated)</label>
                    <input
                        name="metaTags"
                        value={form.metaTags}
                        onChange={onChangeText}
                        className="form-control"
                        style={{ marginTop: 6 }}
                    />
                </div>

                {/* Image */}
                <div style={{ marginBottom: 16 }}>
                    <label style={{ fontWeight: 600 }}>Image</label>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={onPickImage}
                        className="form-control"
                        style={{ marginTop: 6 }}
                    />

                    {form.imagePreview && (
                        <img
                            src={form.imagePreview}
                            alt="preview"
                            style={{
                                marginTop: 10,
                                width: 100,
                                height: 100,
                                borderRadius: 8,
                                objectFit: "cover",
                                border: "1px solid #ccc",
                            }}
                        />
                    )}
                </div>

                <button
                    type="submit"
                    disabled={submitting}
                    className="btn btn-primary"
                    style={{
                        padding: "10px 14px",
                        fontWeight: 600,
                        width: "100%",
                    }}
                >
                    {submitting ? "Saving..." : "Save Blog"}
                </button>
            </form>
        </div>
    );
}
